<template>
	<div class="environment" :class="'environment-' + env">
		Ambiente: {{ getEnvFullName(env) }}
	</div>
</template>

<script>
export default {
	name: 'EnvironmentInfo',
	props: {
		env: {
			type: String,
			required: true,
		},
	},
	methods: {
		getEnvFullName(env) {
			switch (env) {
				case 'dev':
					return 'desenvolvimento';
				case 'stage':
					return 'stage';
				case 'demo':
					return 'demonstração';
				case 'prod':
					return 'produção';
				default:
					return '';
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.environment {
	color: $white;
	text-align: center;
	margin: 0;
	font-size: 16px;
	padding: 5px 0px;
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	z-index: 1;
}

.environment-dev {
	background-color: #73ba4d;
}
.environment-stage {
	background-color: #ff8300;
}
.environment-demo {
	background-color: #ff4500;
}
.environment-prod {
	background-color: #df362d;
}
</style>
